var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('UserLoader'),(this.$store.state.userLoaded)?_c('div',[_c('button',{on:{"click":_vm.newShow}},[_vm._v("create new show")])]):_vm._e(),(this.$store.state.userLoaded)?_c('ShowList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }